import React from 'react'

interface ChatLiveVideoIconProps {
  size?: number
  color?: string
}

export const ChatLiveVideoIcon: React.FC<ChatLiveVideoIconProps> = ({
  size = 32,
  color = '#FFFFFF',
}) => {
  return (
    <div style={{ width: size, height: size }}>
      <svg width={size} height={size} viewBox="0 0 32 32" fill="none">
        <path
          d="M15.8662 6.66663C16.1974 6.66663 16.4666 6.93506 16.4668 7.26624C16.4668 7.59761 16.1976 7.86585 15.8662 7.86585H11.5C9.34623 7.86585 7.59984 9.61252 7.59961 11.7662V20.4996C7.59964 22.6535 9.34611 24.4 11.5 24.4H20.2334C22.3873 24.4 24.1338 22.6535 24.1338 20.4996V16.1324C24.1343 15.8015 24.4023 15.5328 24.7334 15.5328C25.0644 15.5329 25.3325 15.8015 25.333 16.1324V20.4996C25.333 23.3162 23.05 25.5992 20.2334 25.5992H11.5C8.68337 25.5992 6.40043 23.3163 6.40039 20.4996V11.7662C6.40062 8.94978 8.68349 6.66663 11.5 6.66663H15.8662ZM13.3672 13.1852C13.3672 12.5283 14.0786 12.1175 14.6475 12.4459L19.5869 15.2975L19.6865 15.3649C20.1225 15.7027 20.1224 16.3707 19.6865 16.7086L19.5869 16.776L14.6475 19.6285C14.0787 19.9569 13.3674 19.546 13.3672 18.8893V13.1852ZM14.5674 18.2877L18.4678 16.0367L14.5674 13.7858V18.2877ZM22.0146 6.401C22.0878 6.24324 22.3125 6.24334 22.3857 6.401L23.3701 8.53089C23.3905 8.57484 23.4257 8.61017 23.4697 8.63049L25.5986 9.61487C25.7568 9.68796 25.7568 9.91287 25.5986 9.98596L23.4697 10.9694C23.4258 10.9897 23.3905 11.0251 23.3701 11.069L22.3857 13.1989C22.3126 13.3568 22.0877 13.3569 22.0146 13.1989L21.0312 11.069C21.0109 11.025 20.9746 10.9897 20.9307 10.9694L18.8018 9.98596C18.6436 9.91289 18.6437 9.68802 18.8018 9.61487L20.9307 8.63049C20.9747 8.61014 21.0109 8.57493 21.0312 8.53089L22.0146 6.401Z"
          fill={color}
        />
      </svg>
    </div>
  )
}

export default ChatLiveVideoIcon
